var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgYoutube = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.98 5.19c-0.65-1.158-1.357-1.372-2.796-1.452s-5.051-0.138-8.184-0.138-6.751 0.041-8.186 0.137-2.143 0.294-2.801 1.453-1.013 3.149-1.013 6.655v0.012c0 3.492 0.346 5.5 1.015 6.643s1.363 1.368 2.8 1.465 5.052 0.133 8.189 0.133 6.744-0.049 8.183-0.132 2.146-0.307 2.796-1.465c0.677-1.145 1.019-3.151 1.019-6.643v-0.012c-0.001-3.508-0.343-5.5-1.021-6.656zM9 16.35v-9l7.5 4.5z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgYoutube, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/youtube.210a720d.svg";
export { ForwardRef as ReactComponent };